export default __webpack_public_path__ + "static/media/ic-chapter-test.2f496001.svg";